import type { UndefinedOnPartialDeep } from 'type-fest';

import Button from '@ingka/button';
import { ModalFooter } from '@ingka/modal';
import { translate } from '@repo/phrase';
import type { Service } from '@repo/types/service';

import { useTimeWindowFooter } from './time-window-footer.hooks';

interface Props {
    service: UndefinedOnPartialDeep<Service>;
    onSuccess?: () => void;
}

export const TimeWindowFooter = ({ service, onSuccess }: Props) => {
    const { isDisabled, isPending, handleClick } = useTimeWindowFooter({ service, onSuccess });

    return (
        <ModalFooter>
            <Button
                type="primary"
                text={translate('time_windows_select_time_slot_button')}
                disabled={isDisabled}
                loading={isPending}
                onClick={handleClick}
                data-testid="article-time-windows-footer-button"
            />
        </ModalFooter>
    );
};
